import { render } from "./IntegralExchange.vue?vue&type=template&id=783d9308&scoped=true&ts=true"
import script from "./IntegralExchange.vue?vue&type=script&setup=true&lang=ts"
export * from "./IntegralExchange.vue?vue&type=script&setup=true&lang=ts"

import "./IntegralExchange.vue?vue&type=style&index=0&id=783d9308&lang=scss&scoped=true"

import exportComponent from "/Users/luoke/Desktop/新开发代码_git/h5-jalalive/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-783d9308"],['__file',"src/views/me/IntegralExchange.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "783d9308"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('783d9308', __exports__)) {
    console.log('reload')
    api.reload('783d9308', __exports__)
  }
  
  module.hot.accept("./IntegralExchange.vue?vue&type=template&id=783d9308&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('783d9308', render)
  })

}


export default __exports__